<script lang="ts">
	import { HTMLText } from '@atoms';

	let {
		data
	}: {
		data: {
			id: string;
			_modelApiKey: string;
			title: string;
			path: string;
			content: any[];
			preview: string;
		};
	} = $props();
</script>

<a class="container" href={data.path}>
	<h5 class="title text:h4">{data.title}</h5>
	<div><HTMLText text={data.preview} /></div>
</a>

<style lang="scss">
	.container {
		display: flex;
		align-items: stretch;
		flex-direction: column;
		background-color: $colorCardBackground;
		color: $colorCardForeground;
		padding: $gap5;
		gap: $gap4;
		text-decoration: none;

		@include md {
			padding: $gap5 $gap6;
		}

		&:hover h5 {
			text-decoration: underline;
		}
	}
</style>
